import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private count = 0;

    private readonly _loading$ = new BehaviorSubject<boolean>(false);
    private readonly delayedLoading = this._loading$.pipe(debounceTime(200));

    start(): void {
        this.count++;
        if (this.count == 1) {
            this._loading$.next(true);
        }
    }

    end(): void {
        this.count--;
        if (this.count == 0) {
            this._loading$.next(false);
        }
    }

    get loading(): boolean {
        return this.count > 0;
    }

    get loading$(): Observable<boolean> {
        return this.delayedLoading;
    }
}
